import api from "@/services/api.service";
import { required } from "vuelidate/lib/validators";
import readXlsxFile from "read-excel-file";
import XLSX from 'xlsx'

export default {
  name: "add",
  components: { readXlsxFile },
  props: {},
  data() {
    return {
      caption: "Upload Response",
      upload_form: true,
      mapping_form: false,
      operators: [],
      formField: { title: "", upload_date: "" },
      showField: true,      
      headers: [],
      head: [],
      map_headers: [],
      file: "",
      submitStatus: null,
      loader: false,
      selectedHeaders : [],
      isread: 0
    };
  },
  computed: {},
  validations: {
    formField: {
      title: {
        required
      },
      upload_date: {
        required
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    makeToast(
      message = "",
      title = "Alert",
      variant = "warning",
      time = "3000"
      ) {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: time
      });
    },
    async showMappedForm() {
      if (!this.formField.title) {
        this.makeToast(`Plase enter title.`, 'Alert', 'danger')
        return;
      }
      if (!this.formField.xls_file) {
        this.makeToast(`File is not uploaded.`, "Alert", "danger");
        return;
      }
      if(!this.headers){
        this.makeToast(`Pls make sure the uploded file is proper.`, "Alert", "danger");
        return;
      }
      this.upload_form = false;
      this.mapping_form = true;      
      this.head = this.headers.map(h => {
        return { name: h, value: "" };
      });

      var response = await api.post("admin/mapping_headers/list", "type=agent");
      if (!response)
        this.makeToast(
          "Something went to wrong please try again",
          "Alert",
          "danger",
          6000
          );
      if (response.status == "success") {
        if (response.data != "") {
          for (var key in response.data.data) {
            this.map_headers.push({
              value: response.data.data[key].column_key,
              text: response.data.data[key].column,
              disabled: false,
            });
          }
        } else {
          this.map_headers = [];
          this.makeToast(`No database headers found.`, "Alert", "danger");
        }
      } else this.makeToast(`No database headers found.`, "Alert", "danger");
    },
    cascade: function(e) {
      if (e) {
        this.showField = false;
      } else {
        this.showField = true;
      }
    },
    headerSelect(e,index) {
      this.selectedHeaders[index] = e;      
      this.map_headers.forEach( function(header) {
        header.disabled = false;
        this.selectedHeaders.forEach(function(element) {   
          if(header.value == element)
            header.disabled = true;
        });
      }.bind(this));
    },
    resetSelect(e){
      var indexOf = this.selectedHeaders.indexOf(e);
      this.map_headers.forEach( function(header) {
          if(header.value == e)
          header.disabled = false;
          this.selectedHeaders[indexOf] = null;
      }.bind(this));
      this.head.forEach(function(element) {   
          if(element.value == e)
          element.value = "";
      });
    },
    async save() {
      if(this.selectedHeaders.length == 0){
        this.makeToast("Please select any header", "Alert", "danger");
        return;
    }
      this.loader = true;
      this.formField.map_headers = this.head;
      this.formField.marketing_event_id = this.$route.params.id;
      this.formField.name = this.$route.params.title;
      this.formField.date = this.$route.params.upload_date;
      
      let response = await api.post("admin/marketing-event/map-headers", this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);

      if (response.status == "success") {
        localStorage.removeItem("headers");
        this.makeToast(response.message, "Success", "success");
        this.$router.push({ name: "List Event" });
      } else {
        for (var error in response.errors)
          this.makeToast(response.errors[error], "Alert", "danger", 6000);
      }
      this.loader = false;

    },
    onFileChanged(e) {
      e.stopPropagation();
      e.preventDefault();
      var file = e.target.files[0], results, data, fixedData, workbook, firstSheetName, worksheet;
      var reader = new FileReader();
      if (file.type !=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          this.makeToast("File must  be xlsx", "Alert", "danger");
          return;
         }
     this.isread = 1;
     let head1;
       reader.onload = function(e) {
             data = e.target.result;
             fixedData = fixdata(data);
             workbook = XLSX.read(btoa(fixedData), {type: 'base64'});
             firstSheetName = workbook.SheetNames[0];
             worksheet = workbook.Sheets[firstSheetName];
             head1 = get_header_row(worksheet);
             results = XLSX.utils.sheet_to_json(worksheet);
             results = btoa(results);
  
             //Header and Data Functions
             function get_header_row(sheet) {
                 var headers_xls = [], range = XLSX.utils.decode_range(sheet['!ref']);
                 var C, R = range.s.r; /* start in the first row */
                 for(C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
                     var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
                     var hdr= null; // <-- replace with your desired default 
         
                         if(cell && cell.t) hdr = XLSX.utils.format_cell(cell);
                         if(hdr!=null){
                             headers_xls.push(hdr);
                         }                    
                 }
                 return headers_xls;
             }
  
             function fixdata(data) {
                 var o = "", l = 0, w = 10240;
                 for(; l<data.byteLength/w; ++l) o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));
                 o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
                 return o;
             }
             //End
       }
       setTimeout(() => {
         this.headers = head1; 
         this.formField.xls_file = btoa(fixedData); 
         this.isread = 0;
     }, 3000);
  
     reader.readAsArrayBuffer(file);
  },
  back() {
    this.upload_form = true;
    this.mapping_form = false;
  }
}
};
